import { makeStyles } from '@material-ui/styles';
import { fonts } from '../../../../../theme/fonts';

export const useStyles = makeStyles(() => ({
  errorTitle: {
    fontWeight: 400,
    fontFamily: fonts.Oswald
  }
}));
